"use client";

import { useMemo, useState, useSyncExternalStore } from "react";
import {
	getSavedArticlesSnapshot,
	getSavedArticlesServerSnapshot,
	parseSavedArticles,
	subscribeSavedArticles,
	toggleSavedArticle,
	type SavedArticle,
} from "@/lib/saved-articles";
import styles from "./saved.module.css";

/** 公開記事情報を受け取り、このブラウザーの保存切替ボタンを返す。保存エラーはボタン下に表示する。 */
export default function SaveArticle({ article }: { article: SavedArticle }) {
	const snapshot = useSyncExternalStore(
		subscribeSavedArticles,
		getSavedArticlesSnapshot,
		getSavedArticlesServerSnapshot,
	);
	const articles = useMemo(() => parseSavedArticles(snapshot), [snapshot]);
	const saved = articles.some((item) => item.id === article.id || item.url === article.url);
	const [failed, setFailed] = useState(false);

	/** 現在の記事を保存・解除し、保存拒否時だけ状態を表示する。イベント以外の入力・戻り値・例外なし。 */
	function toggle() {
		setFailed(!toggleSavedArticle(article));
	}

	return (
		<span className={styles.saveControl}>
			<button
				type="button"
				className={styles.saveButton}
				aria-pressed={saved}
				aria-label={(saved ? "保存を解除: " : "あとで読むに保存: ") + article.title}
				onClick={toggle}
			>
				<svg
					viewBox="0 0 24 24"
					width="15"
					height="15"
					aria-hidden="true"
					fill={saved ? "currentColor" : "none"}
					stroke="currentColor"
					strokeWidth="1.7"
				>
					<path d="M6 4h12v17l-6-4-6 4V4Z" strokeLinejoin="round" />
				</svg>
				{saved ? "保存済み" : "あとで読む"}
			</button>
			{failed && (
				<span className={styles.error} role="status">
					保存できませんでした。ブラウザーの保存設定をご確認ください。
				</span>
			)}
		</span>
	);
}
